import type { FC } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface Props {
  direction: 'older' | 'newer';
  loading: boolean;
  onClick: () => void;
  /** e.g. "Load older messages", "Load older emails". */
  label: string;
}

const PILL =
  'inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-muted/70 text-foreground/80 text-[11px] font-medium shadow-sm';

/**
 * The pill at a thread's top or bottom that loads the next page, shared by the
 * SMS and email threads. It shows pulsing dots while the page loads.
 */
export const ThreadPagerPill: FC<Props> = ({ direction, loading, onClick, label }) => (
  <div className="flex justify-center py-2">
    {loading ? (
      <span className={PILL} role="status" aria-label="Loading">
        {[0, 180, 360].map((delay) => (
          <span
            key={delay}
            className="animate-dot-pulse inline-block h-1 w-1 rounded-full bg-foreground/70"
            style={{ animationDelay: `${delay}ms` }}
          />
        ))}
      </span>
    ) : (
      <button
        type="button"
        onClick={onClick}
        className={`${PILL} hover:bg-muted hover:text-foreground transition-colors cursor-pointer`}
      >
        {direction === 'older' ? (
          <ChevronUp className="h-3.5 w-3.5" />
        ) : (
          <ChevronDown className="h-3.5 w-3.5" />
        )}
        {label}
      </button>
    )}
  </div>
);
